import { useSearch } from "~/core/composables/useSearch";
import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import {
  Filters,
  type FiltersSelection,
  FiltersType,
  OPERATOR_RSQL_IN,
} from "~/core/models/filters";
import type { DtwinsMetricsCertificate } from "~/modules/dashboard/models/DtwinsMetricsCertificate.interface";
import dtwinService from "~/modules/dtwin/services/dtwin.service";

export function useFetchDtwinMetricsCertificate({
  organizationCode,
}: UseFetchParameters) {
  const appliedFilters: FiltersSelection = new Map([
    [
      Filters.SECTORS,
      { key: "sectorCode", operator: OPERATOR_RSQL_IN, value: [] },
    ],
  ]);

  const { searchParams, filters, setFilter, search, onSearch } = useSearch(
    FiltersType.RSQL,
    appliedFilters,
  );

  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);
  const result: Ref<DtwinsMetricsCertificate | undefined> = ref();

  async function fetchData(): Promise<void> {
    error.value = undefined;
    isLoading.value = true;

    if (organizationCode) {
      const response = await dtwinService.getDtwinsMetricsCertficateState(
        organizationCode,
        searchParams.value,
      );

      if (LxcError.check(response)) {
        error.value = response;
      } else {
        result.value = response;
      }
    } else {
      throw new Error("Organization code is undefined");
    }
    isLoading.value = false;
  }

  return {
    filters,
    setFilter,
    search,
    onSearch,
    error,
    isLoading,
    result,
    fetchData,
  };
}
